module.exports = __webpack_public_path__ + "img/home-delivery_medium.98fafb82.webp";